// Lib
import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

// Components
import OrderProductDetails from '../../../Modals/OrderProductDetails/OrderProductDetails';

// Hooks
import useUser from '../../../../../hooks/useUser';
import useUI from '../../../../../hooks/useUI';
import useUnavailableForOrderProduct from '../../../../../hooks/useUnavailableForOrderProduct';

// Actions
import { OpenModal } from '../../../../../actions/modal';

// Utils
import { getProductTotalItemsOrdered } from '../../../../../pages/OrderHistory/utils/getQuantity';

// Styles
import { useStyles } from './GridContentStyles';

const useGridContent = ({
  product,
  order,
  orderItem,
  isRecurring,
  addressesCount,
}) => {
  const { product_available_qty, order_limit } = product || {};

  const { isUnavailableForOrder, unavailableLabel } =
    useUnavailableForOrderProduct(product, true);

  const { isMobileMode, isTabletMode, isDesktopMode } = useUI();

  const isOutOfStock = product_available_qty === 0;

  const dispatch = useDispatch();
  const { isKiteUser } = useUser();
  const { classes, cx } = useStyles({
    isKiteUser,
    order_limit,
    isMobileMode,
    isTabletMode,
    isDesktopMode,
    isOutOfStock,
  });

  const onOpenModal = useCallback(() => {
    dispatch(
      OpenModal({
        Component: OrderProductDetails,
        props: {
          productId: product.product_id,
          isFullScreen: isTabletMode,
          order,
          orderItem,
          addressesCount,
          isRecurring,
          paddingContent: {
            xl: '50px 40px 50px',
            lg: '60px 28px 30px',
            md: '40px 12px 16px',
          },
        },
        styles: {
          width: 'min(90vw, 1143px)',
        },
      }),
    );
  }, [
    dispatch,
    product,
    order,
    isTabletMode,
    orderItem,
    addressesCount,
    isRecurring,
  ]);

  const totalOrdered = useMemo(
    () => getProductTotalItemsOrdered(product, orderItem, addressesCount),
    [product, orderItem, addressesCount],
  );

  return {
    isUnavailableForOrder,
    unavailableLabel,
    isMobileMode,
    isTabletMode,
    isDesktopMode,
    isOutOfStock,
    classes,
    cx,
    onOpenModal,
    totalOrdered,
  };
};

export default useGridContent;
